import { useState, useRef, useEffect } from 'react';
import styles from '../emergencyAlert.module.css';
import AIEduToast from '../../../components/Toast/AIEduToast';
import AIEduDropDown from '../../../components/DropDown/AIEduDropDown';
import TagSelectionDialog from './TagSelectionDialog';
import {
    setToastComponent,
    showErrorToast,
    showSuccessToast,
} from '../../../services/setup/ApiResponseHandler';

const TagManagement = ({ f, selectedTags, setSelectedTags, selectedOperator, setSelectedOperator }) => {
    const [showTagSelectionDialog, setShowTagSelectionDialog] = useState(false);
    const [addingTags, setAddingTags] = useState(false);
    const toastRef = useRef(null);

    const operatorOptions = [
        { label: f({ id: 'AI_EDU_AND' }), value: 'AND' },
        { label: f({ id: 'AI_EDU_OR' }), value: 'OR' }
    ];

    const handlePlusClick = () => {
        setShowTagSelectionDialog(true);
    };

    const handleConfirmTagSelection = async (tagsToAdd) => {
        setAddingTags(true);
        try {
            // In real implementation, make API call to add tags to alert
            // await API.addTagsToAlert(organizationId, alertId, { tagIds: selectedAvailableTags });

            // For now, just add to local state
            const newTags = tagsToAdd.map((tag) => ({
                ...tag,
                tagId: tag.id, // Map the id from tag selection to tagId for consistency
                id: Date.now() + Math.random(), // Generate unique ID for demo
            }));

            setSelectedTags([...selectedTags, ...newTags]);
            showSuccessToast(f({ id: 'AI_EDU_TAGS_ADDED_SUCCESSFULLY' }));

            // Close dialog
            setShowTagSelectionDialog(false);
        } catch (error) {
            showErrorToast(f({ id: 'AI_EDU_ERROR_ADDING_TAGS' }));
        } finally {
            setAddingTags(false);
        }
    };

    const handleCancelTagSelection = () => {
        setShowTagSelectionDialog(false);
    };

    const removeTag = (tagId) => {
        const updatedTags = selectedTags.filter((tag) => tag.tagId !== tagId);
        setSelectedTags(updatedTags);
    };

    // Initialize toast
    useEffect(() => {
        setToastComponent(toastRef.current);
    }, []);

    return (
        <>
            <div className={styles.tag_management_header}>
                <div className={styles.emergency_alert_textStyle}>
                    {f({ id: 'AI_EDU_SUPPORTING_DEVICES_TEXT' })}
                </div>
            </div>
            <div className={styles.tag_management_container}>
                <div className={styles.tag_toggle_fixed}>
                    <AIEduDropDown
                        value={selectedOperator}
                        options={operatorOptions}
                        onChange={(e) => setSelectedOperator(e.value)}
                        placeholder={f({ id: 'AI_EDU_SELECT_OPERATOR' })}
                        className={styles.operator_dropdown}
                    />
                </div>
                <div className={styles.tag_management_content}>
                    <div className={styles.tags_list}>
                        <div
                            className={styles.tag_add_button_fixed}
                            onClick={handlePlusClick}
                        >
                            <i className='pi pi-plus' />
                        </div>

                        {selectedTags.map((tag) => (
                            <div key={tag.tagId} className={styles.tag_item}>
                                <span className={styles.tag_name}>
                                    {tag.name || tag.tagName}
                                </span>
                                <i
                                    className={`pi pi-times ${styles.tag_remove_icon}`}
                                    onClick={() => removeTag(tag.tagId)}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <TagSelectionDialog
                visible={showTagSelectionDialog}
                onHide={handleCancelTagSelection}
                onConfirm={handleConfirmTagSelection}
                f={f}
                loading={addingTags}
                selectedTags={selectedTags}
            />
            <AIEduToast ref={toastRef} />
        </>
    );
};

export default TagManagement;
